import { ChipOwnProps, Chip } from '@mui/material';

const TransactionsDataGridStatusChip = ({ status }: { status: string }) => {
  let color: ChipOwnProps['color'];
  switch (status) {
    case 'CANCELLED':
      color = 'error';
      break;
    case 'FAILED':
      color = 'error';
      break;
    case 'PENDING':
      color = 'warning';
      break;
    case 'PROCESSED':
      color = 'success';
      break;
    default:
      color = 'default';
  }
  return (
    <Chip label={status} color={color} data-testid="TransactionStatusChip" />
  );
};

export default TransactionsDataGridStatusChip;
